<template>
  <span>{{ elapsedTime }}</span>
</template>

<script>
export default {
  props: {
    dateTime: { type: Object, require: true, },
  },
  computed: {
    elapsedTime() {
      if (!this.$props.dateTime) {
        return '?'
      }
      const now = (new Date()).getTime() / 1000
      const seconds = this.$props.dateTime.seconds
      const sec = now - seconds
      const min = (now - seconds) / 60
      if (min < 2) {
        return '< 1 minute'
      }
      if (min < 60) {
        return `${Math.floor(min)} minutes`
      }
      const hour = (now - seconds) / 60 / 60
      if (hour < 1) {
        return '1 hour'
      }
      if (hour < 24) {
        return `${Math.floor(hour)} hours`
      }
      const days = (now - seconds) / 60 / 60 / 24
      if (days < 2) {
        return '1 day'
      }
      return `${Math.floor(days)} days`
      /*
      const dt = new Date(this.$props.dateTime.seconds * 1000)
      return `${dt.getFullYear()}/${dt.getMonth()}/${dt.getDate()}`
      */
    },
  }
}
</script>
